import { SacredImage } from "./SacredImage";
import { SacredIcon } from "./SacredIcon";

export function FestivalImage({ src, alt, size = "detail", className, testId }) {
  if (size === "icon") {
    return <SacredIcon src={src} alt={alt} className={className || "w-10 h-10 flex-shrink-0"} testId={testId} />;
  }
  const imgSize = size === "thumb" || size === "row" ? size : "detail";
  return (
    <SacredImage
      src={src}
      alt={alt}
      variant="festival"
      size={imgSize}
      className={className}
      testId={testId}
    />
  );
}
